/**
 * The location-state marker that distinguishes "the app was entered at its
 * root" from "the user opened a deep link".
 *
 * `/` (and `/signin` when already authenticated) redirect to the default
 * route, and only that redirect carries this marker. WorkspaceUrlSync restores
 * the persisted active tab's URL exclusively on a marked entry — an unmarked
 * landing is a bookmark, a shared URL, or an inbox digest link, and the URL
 * the user asked for has to win.
 */

/** Location state attached to the app's root → default-route redirect. */
export const APP_ENTRY_STATE = { restoreTab: true } as const;

/** True when a location's state carries the root-entry marker. */
export function isAppEntry(state: unknown): boolean {
  return (state as { restoreTab?: boolean } | null)?.restoreTab === true;
}
